export const issues = {
  "key": null,
  "response": {
    "code": "1",
    "errorCode": "0000",
    "message": null
  },
  "data": {
    "version": {
      "version": 1,
      "last_up_time": "2018-04-25T17:21:00.2076692+08:00",
      "expired": 7200
    },
    "value": [{
      id: 1,
      title: 'LRP忠诚顾客回馈计划',
      subItem: [{
        id: 1,
        title: "什么是忠诚顾客回馈计划 Loyalty Rewards Program（LRP轻松购）？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>忠诚顾客回馈计划（LRP轻松购计划），是为每一位忠诚顾客精心设计的优惠购物计划，让您在体验美好的精油产品同时，享受更多专属福利。</p>",
      }, {
        id: 2,
        title: "如何加入忠诚顾客回馈计划（LRP轻松购）？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>注册，并首张订单≥100点即可成为多特瑞优惠顾客，且勾选同意加入“忠诚顾客回馈计划（LRP轻松购）”。</p>",
      }, {
        id: 3,
        title: "忠诚顾客回馈计划（LRP轻松购）可享哪些优惠和福利？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>加入忠诚顾客回馈计划，并符合福利规则，有机会可享六大优惠福利：</p><p style='font-size: 14px;margin: 10px 0;'>福利1：专属套装享实惠</p><p style='font-size: 14px;margin: 10px 0;'>福利2：回馈点数换产品</p><p style='font-size: 14px;margin: 10px 0;'>福利3：每月一物免费拿</p><p style='font-size: 14px;margin: 10px 0;'>福利4：累积回馈百分比</p><p style='font-size: 14px;margin: 10px 0;'>福利5：持续购买免运费</p><p style='font-size: 14px;margin: 10px 0;'>福利6：福利加码送好礼</p>",
      }, {
        id: 4,
        title: "什么是LRP轻松购订单",
        content: "<p style='font-size: 14px;margin: 10px 0;'>首先，注册成为优惠顾客的首月，且勾选同意加入忠诚顾客回馈计划；</p><p style='font-size: 14px;margin: 10px 0;'>然后，次月起的订单，即为LRP轻松购订单。</p><p style='font-size: 14px;margin: 10px 0;'>注意：首购套装，及部分产品页面明确标明不计入LRP轻松购的产品除外。</p>",
      }, {
        id: 5,
        title: "为什么第一个月不是LRP轻松购订单",
        content: "<p style='font-size: 14px;margin: 10px 0;'>忠诚顾客回馈计划，是公司对于持续购买顾客的一种回馈奖励。</p><p style='font-size: 14px;margin: 10px 0;'>所以，当您成为优惠顾客，并且创建忠诚顾客回馈计划轻松购后，只有当您在次月订购的LRP轻松购订单开始，才开始享受忠诚顾客回馈计划的相应奖励。</p>",
      }, {
        id: 6,
        title: "LRP轻松购自动提醒日期可设定为哪些日期？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>您可以根据自己实际需要设定提醒日期，每月月中15日（1天）和月底26日（含）及之后的日期不可设定。您会在设定的提醒日当天中午12点收到通知提醒。</p>",
      }, {
        id: 7,
        title: "如何修改我的LRP轻松购短信提醒日期",
        content: "<p style='font-size: 14px;margin: 10px 0;'>登录官网、微信或APP，进入个人中心-LRP轻松购，点击编辑日期，就可以修改LRP轻松购的短信提醒日期啦。</p>",
      }, {
        id: 8,
        title: "回馈百分比如何可以增长？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>新优惠顾客从10%为起始，当连续三个月购买每月单笔LRP轻松购订单50产品点数以上，每三个月百分比即可增长5%，最高可增长至30%；回馈百分比越高，订购同样订单点数可获得的回馈点数越多。</p><p style='font-size: 14px;margin: 10px 0;'>注意：</p><p style='font-size: 14px;margin: 10px 0;'>1. 如果某月没有LRP订单，或订单的产品点数为0，则百分比会降回10%，需重新开始累计（即每月至少有一张订单点数为1点以上LRP订单，才可维持百分比）；</p><p style='font-size: 14px;margin: 10px 0;'>2. 忠诚顾客回馈计划是从注册第二月才开始累计，也就是注册完成且当月勾选加入LRP轻松购计划，第二个月开始才是LRP订单。</p><p style='font-size: 14px;margin: 10px 0;'>（举例：8月注册并加入LRP轻松购计划，9、10、11月均有单笔50点以上LRP订单，12月18日百分比升级为15%）；</p><p style='font-size: 14px;margin: 10px 0;'>3. 海外购平台订单也可参加。</p>",
      }, {
        id: 9,
        title: "如果当月订单1~49产品点数之间会如何",
        content: "<p style='font-size: 14px;margin: 10px 0;'>顾客连续每个月购买单笔LRP轻松购订单在1~49产品点数之间，可保留回馈百分比，但此单不会产生回馈点数。</p>",
      }, {
        id: 10,
        title: "产品点数和回馈点数的区别？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>产品点数（PV）：每个产品都有相应的产品点数，注意有些产品点数为0；</p><p style='font-size: 14px;margin: 10px 0;'>订单点数：即订单中所有产品点数的总和（注：用回馈点数兑换的产品点数不计入订单点数）；</p><p style='font-size: 14px;margin: 10px 0;'>回馈点数（PT，Points）：可用于兑换喜爱的产品，单笔LRP订单满50产品点数以上，乘以订单月的百分比，可获得回馈点数，于次月18日到账。回馈点数自获得之日起有效期为12个月。</p>",
      }, {
        id: 11,
        title: "什么是每月一物？如何获得？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>参加忠诚顾客回馈计划的顾客，公司每月会精选一款产品作为每月一物，赠送给符合条件的顾客。</p><p style='font-size: 14px;margin: 10px 0;'>在您加入LRP轻松购次月起，每月1-15日，单笔LRP轻松购订单≥125点，即可免费随单获赠每月精选产品</p><p style='font-size: 14px;margin: 10px 0;'>温馨提示：</p><p style='font-size: 14px;margin: 10px 0;'>1. 每个账户每月只可享有一次获得每月一物赠品的机会；</p><p style='font-size: 14px;margin: 10px 0;'>2. 海外购平台订单也可参加（不含国际市场订单），海外购订单无法随单配送赠品，赠品将于当月22日左右另行单独寄送；</p>",
      }, {
        id: 12,
        title: "LRP轻松购如何免运费？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>首先必须选择参加LRP轻松购，并且连续6个月每月完成单张LRP轻松购订单满125PV，从第7个月的LRP轻松购订单开始，您可享受单张LRP轻松购订单满125PV免运费的礼遇。</p><p style='font-size: 14px;margin: 10px 0;'>（海外购平台订单可计入连续月订单中，但目前海外购订单暂不享受免运费礼遇。）</p>",
      },{
        id: 13,
        title: "如果LRP轻松购订单中断，如何能再获得免运费礼遇？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>如果期间有某月未完成LRP轻松购订单满125PV，免运费礼遇将中断，您可从次月起重新累积，即连续完成6个月单张订单满125PV，即可从第7个月在符合条件的前提下再次开始享受免运费的礼遇。</p>",
      }, {
        id: 14,
        title: "什么是LRP Plus？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>LRP Plus：2020年1月1日-12月31日新注册的多特瑞忠诚顾客，次月起连续完成3个月和6个月单笔LRP轻松购订单≥125点，可分别免费获赠专属回馈好礼一份，礼品将于注册起第4和第7个月的≥125点的单笔订单随单附赠。</p><p style='font-size: 14px;margin: 10px 0;'>温馨提示：</p><p style='font-size: 14px;margin: 10px 0;'>1. LRP Plus活动期间，每个账户可获得连续3个月和连续6个月LRP轻松购专属回馈好礼各一次</p><p style='font-size: 14px;margin: 10px 0;'>2. 跨境通平台订单可计入LRP Plus活动中，注册首月订单及国际市场订单不计入LRP Plus活动中</p><p style='font-size: 14px;margin: 10px 0;'>3. 若达标订单于BOGO期间订购，礼品将于BOGO活动结束后7个工作日左右另行单独寄送</p><p style='font-size: 14px;margin: 10px 0;'>4. 若达标订单是跨境通平台订单，礼品将于次月12日左右另行单独寄送。</p><p style='font-size: 14px;margin: 10px 0;'>5. 礼品寄送地址为达标订单所留地址。</p><p style='font-size: 14px;margin: 10px 0;'>6. 如有订单退换货导致不满125点时，需要将对应受赠一并退还（赠品已经拆封的需照价减扣）</p><p style='font-size: 14px;margin: 10px 0;'>7. 本活动仅限中国大陆市场注册的顾客参加</p>",
      }, {
        id: 15,
        title: "如果取消LRP轻松购，会有什么影响？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>如果取消LRP轻松购，那您的订单将会恢复成标准订单，若您之前有资格参与免运费的礼遇，您的免运费礼遇也将被取消，同时，相关需要LRP轻松购订单的促销或奖励活动，您也将无法参与。</p>",
      }, ],
    },{
      "id": 2,
      "title": "网站登录问题",
      "subItem": [{
        "id": 1,
        title: "忘记优惠顾客号码",
        "content": "<p style='font-size: 14px;margin: 10px 0;'>您如果不记得优惠顾客号码，可以通过网站和APP登陆页面，或微信公众号个人中心，点击“忘记PC号”找回。</p>"
      }, {
        "id": 2,
        title: "忘记网站登陆密码",
        "content": "<p style='font-size: 14px;margin: 10px 0;'>1. 您如果不记得密码，可以通过网站和APP登录页面，或微信公众号个人中心，点击“忘记密码”进行重置密码</p><p style='font-size: 14px;margin: 10px 0;'>2. 如果您收不到手机验证码，您可致电客服热线或发邮件至客服邮箱提供您的优惠顾客编号及身份证件照，请客服专员协助。</p>"
      },{
        "id":3,
        title:'优惠顾客号码暂停了，如何激活？',
        content:"<p style='font-size: 14px;margin: 10px 0;'>如顾客账户较长时间未使用，再次用账号密码登录时，出现提示“该账户已不活动，是否选择激活账户”，点“确认”即可进入自助激活申请流程。</p><p style='font-size: 14px;margin: 10px 0;'>也可直接点击登录界面的“账户激活”链接，直接进入激活流程。</p><p style='font-size: 14px;margin: 10px 0;'>官网、微信、APP登录界面，均可申请激活。</p><p style='font-size: 14px;margin: 10px 0;'>该账户激活功能，仅限中国市场顾客。</p>"
      }]
    }, {
      "id": 3,
      "title": "注册问题",
      "subItem": [{
        "id": "1",
        title: "如何成为优惠顾客",
        "content": "<p style='font-size: 14px;margin: 10px 0;'>注册，并首张订单购买100产品点数以上，即可申请成为优惠顾客。多特瑞官网、APP或微信均可进行注册。</p>"
      }, {
        "id": "2",
        title: "成为优惠顾客的好处",
        "content": "<p style='font-size: 14px;margin: 10px 0;'>优惠顾客可享有优惠价格购买产品（约为零售价的6.5-7折），以及参加忠诚顾客回馈计划等丰富多彩的优惠活动。</p>"
      }, {
        "id": "3",
        title: "优惠顾客注册中的朋友如何填写",
        "content": "<p style='font-size: 14px;margin: 10px 0;'>朋友是填写您朋友的优惠顾客号码及姓名，如果您是通过其他方式了解到多特瑞的，您可以联系客服，我们的客服专员会协助您的。</p>"
      }, {
        "id": "4",
        title: "注册首购套装",
        "content": "<p style='font-size: 14px;margin: 10px 0;'>每位新优惠顾客注册首单，可享有首购套装优惠价（点此至下载专区，点击首购套装了解详情）</p>"
      }, {
        "id": "5",
        title: "注册支付成功没有看到优惠顾客号码",
        "content": "<p style='font-size: 14px;margin: 10px 0;'>您可以在您的帐户信息中看到您的优惠顾客号码，如果仍查询不到，您可以通过网站或APP的登录页面，或微信公众号个人中心点击“忘记PC号”找回，也可联系客服，请客服专员协助。</p>"
      },{
        id:"6",
        title:'不是优惠顾客可以购买产品吗',
        content:'可以购买。可根据需要注册申请为零售顾客，原价购买产品。',
      }]
    }, {
      id: 4,
      title: '订购问题',
      subItem: [{
        id: 1,
        title: "如何订购产品？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>以下渠道均可订购产品：</p><p style='font-size: 14px;margin: 10px 0;'>1. 官方网站：https://china.doterra.cn</p><p style='font-size: 14px;margin: 10px 0;'>2. 官方微信：doTERRA_CN<p style='font-size: 14px;margin: 10px 0;'>3. 精油生活馆（精油生活馆目前仅供订购自提四款首购套装）</p>",
      }, {
        id: 2,
        title: "订单下错了怎么办？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>公司系统的整个订单流程都是自动化处理，如果是支付后30分钟内发现订购错误，可在历史订单中自行取消该订单，订单费用将在1个工作日左右原路退回支付账户。</p><p style='font-size: 14px;margin: 10px 0;'>支付30分钟后，订单一经进入仓库操作阶段，将无法再行取消，还请理解。</p>",
      }, {
        id: 3,
        title: "回馈点数如何兑换使用",
        content: "<p style='font-size: 14px;margin: 10px 0;'>回馈点数兑换需在订购LRP订单时使用：</p><p style='font-size: 14px;margin: 10px 0;'>1. 每次兑换回馈点数不可超过订单总产品点数的2倍。举例：订单产品点数为50点，那么该张订单顾客最多可以兑换使用100点回馈点数；</p><p style='font-size: 14px;margin: 10px 0;'>2. 在挑选产品进入购物车，并点击前往结账后，在结账页面的产品列表中可点击“点数兑换”进行兑换操作。</p><img class='img-responsive' style='margin: 20px 0;display: block;max-width: 800px;height: auto;' src='https://doc.doterra.cn/uploads/cvo/static/图片 1.png'>",
      }, {
        id: 4,
        title: "产品积分如何兑换使用",
        content: "<p style='font-size: 14px;margin: 10px 0;'>在挑选产品进入购物车，并点击前往结账后，在结账页面的产品列表下的产品积分支付框内，输入要使用的产品积分，注意：</p><p style='font-size: 14px;margin: 10px 0;'>1. 产品积分不得超过整笔订单金额的2/3；</p><p style='font-size: 14px;margin: 10px 0;'>2. 回馈点数与产品积分不得在同一笔订单中同时使用。</p><img class='img-responsive' style='margin: 20px 0;display: block;max-width: 800px;height: auto;' src='https://doc.doterra.cn/uploads/cvo/static/图片 2.png'>",
      }, {
        id: 5,
        title: "订购产品可以用哪些支付方式？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>公司不同平台支持的支付方式有：</p><p style='font-size: 14px;margin: 10px 0;'>官网：微信、支付宝、云闪付、银联卡</p><p style='font-size: 14px;margin: 10px 0;'>APP：微信、支付宝</p><p style='font-size: 14px;margin: 10px 0;'>微信：微信</p>",
      }, {
        id: 6,
        title: "网站支付是否有限额？",
        content: "<p style='font-size: 14px;margin: 10px 0;'>公司官网支付并未做限额，您可查看您的手机或支付软件是否做了限额设置，或联系银行查看是否有做过限额设置。</p>",
      }, {
        id: 7,
        title: "订单生成后什么时候可以发货",
        content: "<p style='font-size: 14px;margin: 10px 0;'>一般1天内发出，如遇大促、月初和月中订单高峰时可能略有延迟。</p><p style='font-size: 14px;margin: 10px 0;'>一般发货后，江浙沪1~2个工作日，国内其他地区3~5个工作日，较偏远地区（如新疆、青海、甘肃、西藏、内蒙古、四川、云南等地）视快递运送情况略有延迟。</p><p style='font-size: 14px;margin: 10px 0;'>您可在历史订单中查看订单的物流信息，了解配送进展。</p>",
      }, {
        id: 8,
        title: "哪家快递发货",
        content: "<p style='font-size: 14px;margin: 10px 0;'>公司一般运送选择京东快递，个别较远地区可能会转运其他快递</p>",
      }, {
        id: 9,
        title: "如何查询快递",
        content: "<p style='font-size: 14px;margin: 10px 0;'>可在“历史订单”中查询相应订单的物流单号和配送进展。</p><p style='font-size: 14px;margin: 10px 0;'>包裹到达当地后，请关注手机短信推送的派送员信息，并留意派送员联络。</p>",
      }, {
        id: 10,
        title: "是否可以邮寄国外地址",
        content: "<p style='font-size: 14px;margin: 10px 0;'>暂时只能寄往中国大陆（港澳台除外）</p>",
      }, {
        id: 11,
        title: "产品收货",
        content: "<p style='font-size: 14px;margin: 10px 0;'>当您收到订购产品时，请您先检查外包装，如快递外箱发现破损或漏油，您可直接拒收。</p><p style='font-size: 14px;margin: 10px 0;'>如快递外箱包装无问题，请您尽快打开仔细核对您的订单，如有问题，请联系客服。</p>",
      }, {
        id: 12,
        title: "选择精油生活馆自提后多久可以去取货",
        content: "<p style='font-size: 14px;margin: 10px 0;'>选择了精油生活馆自提, 当订单付款成功后, 当天可以至所选精油生活馆取货，请记得提前准备好自提需要携带的资料。</p>",
      }, {
        id: 13,
        title: "精油生活馆自提订单，如有事未能在14天领取怎么办",
        content: "<p style='font-size: 14px;margin: 10px 0;'>如果在14天内，您未能到店领取您的产品，我们将自动协助您退货退款。</p>",
      }]
    }, {
      id: 5,
      title: '产品及售后',
      subItem: [{
        id: 1,
        title: "产品品质",
        content: "<p style='font-size: 14px;margin: 10px 0;'>我们的精油产品都是经过CPTG严格检验程序检测的，确保每一瓶精油的质量及纯度，是安全、纯正、有效的。</p>"
      }, {
        id: 2,
        title: "产品应如何存放",
        content: "<p style='font-size: 14px;margin: 10px 0;'>精油产品存放请避光、避高温、避免潮湿环境，建议最好存放在木盒中。</p>",
      }, {
        id: 3,
        title: "如何申请发票",
        content: "<p style='font-size: 14px;margin: 10px 0;'>登录官网或APP，进入历史订单，选择“查看”需开票订单，点击“申请开具发票”，即可便捷开具电子发票（增值税普通发票）。</p>"
      },{
        id: 4,
        title: "如何办理退换货",
        content: "<p style='font-size: 14px;margin: 10px 0;'>凡通过多特瑞（上海）商贸有限公司认可的渠道购买的产品，自购买之日起30天内，只要包装未拆封并且无污染可正常销售的产品，均可凭商品清单办理退换货，如有已开具的纸质发票请在回邮产品时一并寄回。</p><p style='font-size: 14px;margin: 10px 0;'>进入历史订单中，选择需退货的订单，点击“申请退货“。</p>",
      },{
        id: 5,
        title: "申请退货后多久退款",
        content: "<p style='font-size: 14px;margin: 10px 0;'>公司收到退回产品，确认不影响二次出售之日起，一般5个工作日左右原路退回支付账户中。</p>",
      }, {
        id: 6,
        title: "产品有瑕疵，如何处理",
        content: "<p style='font-size: 14px;margin: 10px 0;'>我们会全力确保商品品质，但若还有不全之处，可与我们的客服联系。</p><p style='font-size: 14px;margin: 10px 0;'>在线客服：小多在线</p><p style='font-size: 14px;margin: 10px 0;'>客服电话：400-920-9191</p><p style='font-size: 14px;margin: 10px 0;'>客服邮箱：chinaservice@doterra.com</p>",
      }]
    },]
  },
}